import { useMemo } from 'react';

import map from 'lodash/map';

import { useAllLaborLevelsWithOptionsGet } from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

type ExtraParameters = {
  disabledItemsList?: number[];
};

type Props = BaseFieldProps & ExtraParameters;

const useLaborLevelOptions = ({ disabledItemsList = [] }: ExtraParameters) => {
  const {
    options: baseOptions,
    isSuccess,
    isLoading,
  } = useAllLaborLevelsWithOptionsGet({});
  const options = useMemo(
    () =>
      map(baseOptions, (item) => ({
        ...item,
        disabled: disabledItemsList.includes(item.meta.level),
      })),
    [baseOptions, disabledItemsList]
  );
  return { options, isSuccess, isLoading };
};

const hookParamsGetter = (props: Props): ExtraParameters => ({
  disabledItemsList: props.disabledItemsList,
});

export const { LaborLevelFormSelectField } = createOptionsFieldBuilder({
  prefix: 'LaborLevel',
  useOptionsHook: useLaborLevelOptions,
  extractHookParams: hookParamsGetter,
});
